import { render, staticRenderFns } from "./WelfareCentrePictureIntroduction.vue?vue&type=template&id=6dcf6bb8&scoped=true&"
import script from "./WelfareCentrePictureIntroduction.vue?vue&type=script&lang=js&"
export * from "./WelfareCentrePictureIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcf6bb8",
  null
  
)

export default component.exports